module.exports = __webpack_public_path__ + "static/media/OFmidterm.669b9c14.jpg";